export const searchTypeList: any = {
  removals: {
    label: "Removals",
    value: "removals",
    page: "/dashboard",
    placeholder: "Search a Lead",
  },
};

export const searchDropdownOptions: any = {
  lead: [
    "NEW LEAD",
    "PENDING NEW LEAD",
    "STORAGE ENQ",
    "STORAGE",
    "DEBTOR",
    "EXTERNAL",
    "ESTIMATE",
    "SURVEY",
    "SURVEYED",
    "QUOTE",
    "JOB",
    "PROVISIONAL",
    "AWAITING",
    "CONFIRMED",
    "COMPLETED",
    "ARCHIVED",
    "DISPUTE",
    "LOST",
  ],
  surveyLead: ["PENDING", "IN PROGRESS", "COMPLETED"],
};
